module.exports = __webpack_public_path__ + "2272a12ec0a3fb3836133297cd6e360a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/bandeau-smaller.jpg
// module id = 31
// module chunks = 0